import styled from 'styled-components';

import media from '../../../styles/media.style';

export const distance = (c1, c2) => {
  const degreeToRadian = Math.PI / 180;
  const R = 6371e3; // metres
  const φ1 = c1.lat * degreeToRadian;
  const φ2 = c2.lat * degreeToRadian;
  const Δφ = (c2.lat - c1.lat) * degreeToRadian;
  const Δλ = (c2.lon - c1.lon) * degreeToRadian;

  const a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) + Math.cos(φ1) * Math.cos(φ2) * Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  const d = R * c;

  if (d < 1000) {
    return `${Math.round(d)} m`;
  }
  return `${(d / 1000).toFixed(1)} km`;
};

export const Wrapper = styled.div`
  background-color: lightgrey;
  display: ${({ show }) => (show ? 'block' : 'none')};
  height: 100%;
  left: 0;
  min-width: 300px;
  overflow-y: scroll;
  padding: 15px;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 5;
  -webkit-overflow-scrolling: touch;

  ${media.tabletL`
    display: block;
    max-width: 400px;
    padding: 25px;
    position: unset;
    width: calc(100% / 3);
  `};
`;

export const Salon = styled.div`
  background-color: #333;
  color: white;
  margin-top: 20px;
  padding: 35px;

  &:first-child {
    margin-top: 0;
  }
`;

export const Number = styled.div`
  font-family: sans-serif;
  font-size: 14px;
  width: 25px;
`;

export const Title = styled.div`
  display: flex;
`;

export const Name = styled.div`
  flex-grow: 1;
  font-family: sans-serif;
  font-size: 16px;
`;

export const Distance = styled.div`
  font-family: sans-serif;
  font-size: 16px;
  margin: 0;
`;

export const Detail = styled.div`
  color: lightgrey;
  display: flex;
  align-items: flex-start;
  font-size: 14px;
  margin-top: 10px;
`;

export const Label = styled.div`
  margin-right: 10px;
`;

export const Link = styled.a`
  word-break: break-all;
  :hover {
    text-decoration: underline;
  }
`;

export const Bottom = styled.div`
  align-items: flex-end;
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
`;

export const View = styled.div`
  cursor: pointer;
  font-family: sans-serif;
  font-size: 14px;
  margin-top: 10px;
  text-decoration: underline;
  width: auto;
`;

export const LineImages = styled.div`
  display: flex;
  flex-wrap: wrap;
  position: relative;
  margin: 0 -10px -10px -10px;
  .line-image {
    &:nth-child(3n-2) {
      .tooltip {
        &:before {
          left: 40px;
        }
      }
    }
    &:nth-child(3n-1) {
      .tooltip {
        &:before {
          left: 50%;
        }
      }
    }
    &:nth-child(3n) {
      .tooltip {
        &:before {
          left: auto;
          right: 40px !important;
        }
      }
    }
  }
`;
export const LineImage = styled.div`
  width: 33%;
  .image {
    padding: 10px;
    img {
      width: 100%;
    }
  }
  &:hover,
  &:active {
    .tooltip {
      display: block;
    }
  }
`;
export const LineImageTooltip = styled.div`
  display: none;
  position: absolute;
  left: 0;
  width: 100%;
  margin-top: -110px;
  background: #ffffff;
  color: #000000;
  height: 100px;
  padding: 10px;
  img {
    width: 80px;
    float: left;
    margin-right: 10px;
  }
  .content {
    .name {
      font-weight: bold;
    }
    .description {
      color: #333333;
    }
    &:after {
      content: '';
      display: block;
      clear: both;
    }
  }
  &:before {
    content: '';
    position: absolute;
    top: 100%;
    margin-left: -10px;
    border: 10px solid transparent;
    border-top: 10px solid #fff;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/SalonLocator/ResultSection/List.style.js